module.exports = __webpack_public_path__ + "static/media/website.7c3c9ea3.svg";